import { v4 as uuid } from "uuid";

/**
 * Every mutating request MUST send an Idempotency-Key header. Same key + same
 * payload = safe retry (server returns cached response). Same key + different
 * payload = 409 conflict.
 */
export function newIdempotencyKey(): string {
  return uuid();
}
